<template>
<GeneralContainer>
    <div class="license-invoice-page">
        <Popper v-if="!loading" ref="dropdown" target_id="payment-options-btn" :append_to_body="true" placement="bottom-start">
            <div class="dropdown" v-if="license.license">
                <a v-if="isNotCancelled" @click="updateClick">
                    Update Method of Payment
                </a>
                <a v-if="isNotCancelled" @click="cancelClick">
                    End Subscription
                </a>
                <a v-else @click="restartClick">
                    Restart Subscription
                </a>
            </div>
        </Popper>
		<!-- <ConfirmModal @confirm="cancelSubscription" ref="cancelModal" title="Cancel Subscription" message="Your software will continue to work. Your current update subsciption price will be lost. Reactivating your subscription will be at the current subscription price."></ConfirmModal> -->

        <!-- <ConfirmModal @confirm="cancelSubscription" ref="cancelModal" title="Cancel Subscription" message="Your software will continue to work but will no longer be able to update. Restarting your subscription to get updates may be at a higher price."></ConfirmModal> -->

		<HtmlConfirmModal @confirm="cancelSubscription" ref="cancelModal" title="Cancel Subscription">
			<div>
				<p>
					Your software will continue to work but will no longer be able to update after your license expires.
				</p>
				<p>
					Restarting your subscription at a later date to get updates may be at a higher price.
				</p>
			</div>
		</HtmlConfirmModal>

		<UpdatePaymentModal @submit="updatePayment" @paypal="paypalUpdate" ref="updatePaymentModal"></UpdatePaymentModal>
        <UpdatePaymentModal @submit="restartSubscription" @paypal="paypalRestart" ref="restartPaymentModal"></UpdatePaymentModal>

        <Loader :loading="loading||reloading"></Loader>
        <div v-if="!loading">
            <ol class="breadcrumb">
                <li>
                    <router-link :to="{name:'licenses'}">
                        Licenses
                    </router-link>
                </li>
                <li>
                    <a>
                        {{$route.params.license.split("-")[0]}}
                    </a>
                </li>
            </ol>

            <button @click="paymentOptionsClick" id="payment-options-btn" class="payment-options">
                Edit Payment
            </button>

            <div class="invoice">

                <!-- <header>
                <h2>
                    {{license.license.product}}
                </h2>
                <span v-if="license.license.amount">
                    ${{license.license.amount.split(".")[0]}}/year
                </span>
            </header> -->
            	<section>
	           		<header>
	             		<img src="@/assets/img/kolkin-sos-icon.png" />
	             		<b>{{license.license.product}}</b>
		            </header>
            	</section>
                <section>
                    <div class="left">
                        <div>
                            <a>Licensee</a>
                        </div>
                        <h2>
                            {{license.license.licensee}}
                        </h2>
                    </div>
                    <div class="right">
                        <div>
                            <a>Created</a>
                        </div>
                        <h4>
                            {{license.license.creation | paypal_date}}
                        </h4>

                    </div>
                </section>
                <section v-if="isNotCancelled">
                    <div class="left">
                        <div>
                            <a>Billing Info</a>
                        </div>
                        <div v-if="license.license.payment_acct">
                            <h4>
                                {{license.license.payment_firstname}} {{license.license.payment_lastname}}
                            </h4>
                            <h4>
                                {{license.license.payment_acct}}
                            </h4>
                            <h4>
                                {{license.license.payment_street}}
                            </h4>
                            <h4>
                                {{license.license.payment_zip}}
                            </h4>
                        </div>
                        <div v-else>
                            <h4>Paypal</h4>
                        </div>
                    </div>
                    <div class="right">
                        <div>
                            <a>Next Payment</a>
                        </div>
                        <h4>
                            {{nextPayment}}
                        </h4>
                    </div>
                </section>
                <section v-else>

                    <div class="right">
                        <div>
                            <a>Expiration Date</a>
                        </div>
                        <h4>
                            {{nextPayment}}
                        </h4>
                    </div>
                </section>

                <div>
                    <h2>
                        Payments
                    </h2>
                    <table>
                        <thead>
                            <tr>
                                <th>Date</th>
                                <th>Amount</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="invoice in license.invoices" :key="invoice.invoice_id">

                                <td>
                                    <time>{{invoice.payment_date_formatted | date}}</time>
                                </td>

                                <td>
                                    <span>${{invoice.amount}}</span>
                                </td>

                                <td>
                                    <span v-if="invoice.status=='8'">
                                        Paid
                                    </span>
                                    <span v-else-if="invoice.status=='6'||invoice.status=='7'">
                                        Pending
                                    </span>
                                    <span v-else>
                                        Incomplete
                                    </span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

        </div>
    </div>
</GeneralContainer>
</template>

<script>
import axios from "axios";
import store from "@/store";
import Loader from "@/../submodules/vue-base/components/Loader";
import ConfirmModal from "@/../submodules/vue-base/components/ConfirmModal";
import HtmlConfirmModal from "@/../submodules/vue-base/components/HtmlConfirmModal";
import GeneralContainer from "@/components/base/GeneralContainer";

import format from 'date-fns/format';
import parse from 'date-fns/parse';
import UpdatePaymentModal from "@/components/license/UpdatePaymentModal";
import Popper from "@/../submodules/vue-base/components/Popper";
import {
    mapGetters
} from 'vuex';
export default {

    name: "LicenseInvoice",

    components: {
        Loader,
        ConfirmModal,
		HtmlConfirmModal,
        UpdatePaymentModal,
        GeneralContainer,
        Popper
    },

    data() {
        return {
            loading: true,
            reloading: false,
        }
    },

    created() {
        var temp = this;
        store.dispatch("loadLicense", this.$route.params.license).then(function () {
            temp.loading = false;
        })
    },

    methods: {

        paymentOptionsClick() {
            this.$refs.dropdown.toggle();
        },

        updateClick() {
            this.$refs.updatePaymentModal.open();
        },
        cancelClick() {
            this.$refs.cancelModal.open();
        },
        restartClick() {
            this.$refs.restartPaymentModal.open();
        },
        restartSubscription(paymentInfo) {
            paymentInfo.license = this.$route.params.license;
            var temp = this;
            this.reloading = true;
            axios.put("/api/license/restart", paymentInfo).then(function (response) {
                store.dispatch("loadLicense", temp.$route.params.license).then(function () {
                    temp.reloading = false;
                });
            }).catch(function () {
                temp.reloading = false;
            })
        },
        cancelSubscription() {
            var temp = this;
            this.reloading = true;
            axios.delete("/api/license/invoice", {
                params: {
                    license: this.$route.params.license
                }
            }).then(function (response) {
                store.dispatch("loadLicense", temp.$route.params.license).then(function () {
                    temp.reloading = false;
                });
            }).catch(function () {
                temp.reloading = false;
            })
        },
        updatePayment(paymentInfo) {
            paymentInfo.license = this.$route.params.license;
            console.log(paymentInfo)
            var temp = this;
            this.reloading = true;
            axios.put("/api/license/invoice", paymentInfo).then(function (response) {
				console.log("loading license")
                store.dispatch("loadLicense", temp.$route.params.license).then(function () {
					console.log("license loaded")
					temp.$refs.updatePaymentModal.close();
                    temp.reloading = false;
                });
            }).catch(function () {
                temp.reloading = false;
            })
        },

        paypalUpdate() {
            this.reloading = true;;
            axios.post("/api/paypal/update/express", {
                license_id: this.$route.params.license
            }).then(function (response) {
                var token = response.data.token;

                if (process.env.NODE_ENV === 'production') {
                    window.location = "https://www.paypal.com/cgi-bin/webscr?cmd=_express-checkout&token=" + token + "&useraction=commit";
                } else {
                    window.location = "https://www.sandbox.paypal.com/cgi-bin/webscr?cmd=_express-checkout&token=" + token + "&useraction=commit";
                }

            })
        },
        paypalRestart() {
            this.reloading = true;
            axios.post("/api/paypal/restart/express", {
                license_id: this.$route.params.license
            }).then(function (response) {
                var token = response.data.token;

                if (process.env.NODE_ENV === 'production') {
                    window.location = "https://www.paypal.com/cgi-bin/webscr?cmd=_express-checkout&token=" + token + "&useraction=commit";
                } else {
                    window.location = "https://www.sandbox.paypal.com/cgi-bin/webscr?cmd=_express-checkout&token=" + token + "&useraction=commit";
                }
            })
        },
    },

    computed: {
        nextPayment() {
            if (this.license.license.next_payment) {
                var d = parse(this.license.license.next_payment, 'MMddyyyy', new Date());
                return format(d, 'MM/dd/yyyy');
            } else {

                return "";

            }

        },
        isNotCancelled() {
            return this.license.license.is_cancelled == 'f';
        },
        ...mapGetters(["license"])
    }

}
</script>
